export default "__VITE_ASSET__BhLtnd2c__"